



























import { mapGetters, mapState } from 'vuex'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import FormComponentService from '~/services/form/FormComponentService'
import {
  FIELD_FULL_WIDTH_COLUMNS,
  FIELD_HALF_WIDTH_COLUMNS
} from '~/constants/form/columns'
import { defineComponent } from '@nuxtjs/composition-api'

const FIELDS_NAMES_WITHOUT_LABELS = Object.freeze([
  'category',
  'external_certificate',
  'notes',
  'photos',
  'insurance',
  'user',
  'location',
  'makemodel',
  'finance_options',
  'registration',
  'audits',
  'only_trades',
  'only_leasing',
  'features'
])

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    humanName: {
      type: String,
      required: true
    },
    specs: {
      type: Object,
      required: false,
      default: undefined
    },
    required: {
      type: Boolean,
      required: true
    },
    suggestions: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_FORM_NS, {
      getFieldIdByName: 'getFieldIdByName',
      getFieldValueByName: 'getFieldValueByName',
      getFieldErrorByName: 'getFieldErrorByName'
    }),
    ...mapState(CLASSIFIED_FORM_NS, {
      categoryId: state => state.categoryId,
      categoryIds: state => state.categoryIds,
      isDispatched: state => state.isDispatched,
      fieldColumns: state => state.config?.settings?.fieldColumns,
      pageKey: state => state.pageKey
    }),
    ...mapDeps({
      formComponentService: FormComponentService
    }),
    label() {
      if (
        this.isDispatched &&
        ['boolean', 'offers_enabled_field'].includes(this.type)
      ) {
        return null
      }
      return FIELDS_NAMES_WITHOUT_LABELS.includes(this.name)
        ? null
        : this.humanName
    },
    component() {
      return this.formComponentService.getFieldComponent(this.type)
    },
    placeholder() {
      return this.formComponentService.getPlaceholder(
        this.name,
        this.categoryIds
      )
    },
    columns() {
      if (
        this.name === 'makemodel' &&
        ((this.specs.models && this.specs.models.length === 0) ||
          this.specs.has_models === false)
      ) {
        return FIELD_HALF_WIDTH_COLUMNS
      }
      return (
        (this.fieldColumns && this.fieldColumns[this.name]) ||
        FIELD_FULL_WIDTH_COLUMNS
      )
    },
    id() {
      return this.getFieldIdByName(this.name)
    },
    value() {
      return this.getFieldValueByName(this.name)
    },
    error() {
      // need to do deep-cloning here to avoid getting vuex errors for mutating an immutable object (due to using
      // the same object as backend and frontend error)
      const error = this.getFieldErrorByName(this.name)
      if (typeof error === 'object') {
        return JSON.parse(JSON.stringify(error))
      }
      return error
    },
    description() {
      switch (this.type) {
        case 'price_parked_field':
          return this.$t('price_parked_description')
        case 'home_delivery_field':
          return this.$t('home_delivery_description')
        default:
          return this.specs?.description
      }
    }
  }
})
